import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import SakrebuloActs from './SakrebuloActs';
import SakrebuloActsList from './SakrebuloActsList';
function SkhdomisTsesrigi() {
	const ref = useRef(null);
	const [width, setWidth] = useState(10);
	const { search } = useContext(SearchContext);
	const { language } = useContext(SearchContext);
	const [news, setNews] = useState({});
	const [uniqueYears, setUniqueYears] = useState(new Set());
	const [activeYear, setActiveYear] = useState(null);
	const [actList, setActList]= useState('')



	const [menu, setMenu] = useState({});

	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				setMenu(data.menu);
				Object.entries(menu).map(item => {
					if (item[1].level == 1) {
					}
				});
			});
	}, []);

	useLayoutEffect(() => {
		setWidth(ref.current.offsetWidth);
	});
	const menuName = Object.entries(menu).length
		? Object.entries(menu).find((item) => {
				const windoww = window.location.pathname;
				const result = windoww.split('/').pop();
				const slugg = item[1].slug;
				if (result === slugg) {
					return language == 1 ? item[1].name_geo : item[1].name_eng;
				}
		  })
		: '';

	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span className='big' ref={ref} style={{ marginRight: width / 2 }}>
						{' '}
						{language == 1 ? 'სამართლებრივი აქტები' : 'LEGAL ACTS'}
					</span>

					<span>
						{menuName[1]
							? language == 1
								? menuName[1].name_geo
								: menuName[1].name_eng
							: ''}
					</span>
				</header>
				<div>
					<div className='sakrebulo-landing'>
						<div className='landing-container'>
							<div className='sajaroInfo '>
								<SakrebuloActs actsSlug={actList? actList : 'skhdomis-tsesrigi'} />
							</div>
						</div>
					</div>
					<div className='presscenter-info'><SakrebuloActsList setActList={setActList}/></div>
				</div>
			</div>
		</motion.div>
	);
}

export default SkhdomisTsesrigi;
